import React, {useState, useEffect} from "react";

import DashboardContent from "../content/DashboardContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";
import LoadingBar from 'react-top-loading-bar';

function Dashboard() {
    const [progress, setProgress] = useState(0);
    
    useEffect(()=>{
        setProgress(100);
    },[])
    return(
        <>
        <Navbar />
        <DashboardContent/>
        <LoadingBar
            color='#a11800'
            height={4}
            background='#fff4a1'
            loaderSpeed={2000}
            waitingTime={2000}
            shadow={true}
            progress={progress}
            onLoaderFinished={() => setProgress(0)}
        />
        <Footer />        
        </>
    );
}

export default Dashboard;